/*应用认领服务*/
define('services/appmng/app-claims.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('appClaimsService', ['$filter','ngDialog', '$state', 'OpenApp', 'OpenOther', 'auiDialog','auiUpload',
        function ($filter,ngDialog, $state, OpenApp, OpenOther, auiDialog,auiUpload) {
        function appClaimsService(packageName,callback,callbackapk) {
            ngDialog.open({
                template: 'pages/common/dialog.repeat.upload.apk.html',
                className: '',
                controller: ['$scope', function ($scopeDlg) {
                    $scopeDlg.packageName = packageName;
                    $scopeDlg.uploadApkRepeat=function () {
                        ngDialog.close();
                        if(angular.isFunction(callbackapk)){
                            callbackapk();
                        }
                    };
                    $scopeDlg.close=function () {
                        ngDialog.close();
                        if(angular.isFunction(callback)){
                            callback();
                        }
                    };
                    var regexp = new RegExp(mainCons.servicesConstant.regexp.packageName);
                    if(regexp.test($scopeDlg.packageName)){
                        $scopeDlg.appClaimsPage = systemParaConf.user.appClaimPage+"?packagename="+$scopeDlg.packageName+"&packageType="+"1"
                    }
                }]});
        }
            //下载空包页面
            function getEmptyPkg(packageName,callback) {
                ngDialog.open({
                    template: 'pages/common/dialog.download.empty.package.apk.html',
                    className: '',
                    controller: ['$scope', function ($scopeDlg) {
                        $scopeDlg.close=function () {
                            ngDialog.close();
                            if(angular.isFunction(callback)){
                                callback();
                            }
                        };
                        $scopeDlg.downLoadUrl = sysUrlCfg.emptyApkPkgUrl;
                        //下一步
                        $scopeDlg.next=function () {
                            ngDialog.close();
                            uploadEmptyPkg(packageName,false,callback);
                        }
                    }]
                });
            }


            //应用认领页面上传 flag RPK为true
            function uploadEmptyPkg(packageName,flag,callback) {
                ngDialog.open({
                    template: 'pages/common/upload.claim.apk.html',
                    className: '',
                    controller: ['$scope', function ($scopeDlg) {
                        $scopeDlg.emptyApkMinSize = mainCons.appConstant.appClaims.emptyApkMinSize;
                        $scopeDlg.emptyApkMaxSize = mainCons.appConstant.appClaims.emptyApkMaxSize;
                        $scopeDlg.forumDiversionConf = sysParamCfg.forumDiversionConf;
                        $scopeDlg.isRPK = flag;
                        $scopeDlg.apkChoosed ="上传带签名空包";
                        //select框上的文字
                        $scopeDlg.selectFile="选择带签名空包";
                        $scopeDlg.emptyPkgUrl="";
                        $scopeDlg.sizeTip = ($scopeDlg.isRPK?"R":"A")+("PK的大小要在"+$scopeDlg.emptyApkMinSize+"KB-"+$scopeDlg.emptyApkMaxSize+"KB之间");

                        // 提交空包认领。
                        $scopeDlg.submit =function () {
                            if($scopeDlg.emptyPkgUrl && $scopeDlg.emptyPkgUrl !=""){
                                OpenOther.appClaimsSubmit({req:{
                                    packageName: packageName,
                                    url:$scopeDlg.emptyPkgUrl,
                                    packageType:flag ? 2 : 1
                                }
                                }).then(function (data) {
                                    if(!!data && data.code ==1){
                                        ngDialog.close();
                                        if(angular.isFunction(callback)){
                                            callback();
                                        }
                                        auiDialog.success("应用认领申请已提交成功，请耐心等待管理员审核");
                                    }
                                }).catch(function (data) {
                                    ngDialog.close();
                                    if(angular.isFunction(callback)){
                                        callback();
                                    }
                                })
                            }
                        };
                        // 空包apk上传
                        $scopeDlg.uploadImg =function (files) {
                            var options = {};
                            options.size = [mainCons.appConstant.appClaims.emptyApkMinSize*1024,mainCons.appConstant.appClaims.emptyApkMaxSize*1024];
                            options.ext=$scopeDlg.isRPK ? ".rpk,.RPK":".apk,.APK";
                            options.scene = "40012";
                            auiUpload.upload2openApp(files, '3',options).then(function (fileUrl) {
                                if($scopeDlg.emptyPkgUrl){
                                    auiUpload.clearRemoteFile($scopeDlg.emptyPkgUrl,3);
                                }
                                $scopeDlg.emptyPkgUrl = fileUrl;
                                $scopeDlg.sizeTip =files[0].name;
                            });
                        };
                        // 上一步对应的方法
                        $scopeDlg.preStep =function () {
                            ngDialog.close();
                            getEmptyPkg(packageName,callback);
                        };
                        //对话框关闭 右上角X
                        $scopeDlg.close =function () {
                            ngDialog.close();
                            if(angular.isFunction(callback)){
                                callback();
                            }
                        }
                    }]
                });
            }

        return {
            appClaimsService: appClaimsService,
            getEmptyPkg:getEmptyPkg,
            uploadEmptyPkg:uploadEmptyPkg
        }
    }]);
});

